'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _PlanScorecardCompanyLetter = require('./PlanScorecardCompanyLetter.css');

var _PlanScorecardCompanyLetter2 = _interopRequireDefault(_PlanScorecardCompanyLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VanguardCompanyLetter = (_dec = (0, _reactCssModules2.default)(_PlanScorecardCompanyLetter2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VanguardCompanyLetter, _Component);

  function VanguardCompanyLetter(props) {
    (0, _classCallCheck3.default)(this, VanguardCompanyLetter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VanguardCompanyLetter.__proto__ || (0, _getPrototypeOf2.default)(VanguardCompanyLetter)).call(this, props));

    _this.state = {
      differentPage: _this.props.differentPage || false
    };
    return _this;
  }

  (0, _createClass3.default)(VanguardCompanyLetter, [{
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        'blockquote',
        { styleName: 'company-letter-blockquote' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'To: Vanguard'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'From: ',
            _react2.default.createElement(
              'i',
              null,
              'As You Sow'
            ),
            ' & Concerned Amazon Employees'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dear Fund Manager,'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber, and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts, and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and corporate 401(k) clients like myself to a host of material risks.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Critically, the default 401(k) option for Amazon employees is not invested sustainably. Over 50% of assets invested in the plan are in the default option target date funds from Vanguard. Because these funds are not invested sustainably, millions of dollars in employee savings are being allocated to deforestation-risk investments.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Vanguard needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios, including my 401(k) default option at Amazon.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Thank you.'
        )
      );
    }
  }]);
  return VanguardCompanyLetter;
}(_react.Component), _class2.propTypes = {
  differentPage: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = VanguardCompanyLetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/VanguardCompanyLetter.js
// module id = 1410
// module chunks = 0